import { getCountryLabel } from '@/lib/countries/countryLabels';
import { parseCityCountry } from '@/lib/cityCountry';

/** Resolve city + country ISO from explicit fields or legacy `location` ("City, Country"). */
export function resolveParticipantPlace(p: {
  city?: string;
  country?: string;
  location?: string;
}): { city: string; countryIso: string } {
  let city = (p.city ?? '').trim();
  let countryIso = (p.country ?? '').trim();
  if (!city && !countryIso) {
    const leg = (p.location ?? '').trim();
    if (leg) {
      const x = parseCityCountry(leg);
      city = x.city;
      countryIso = x.country;
    }
  }
  return { city, countryIso };
}

export function resolvePartner2Place(p: {
  partner2City?: string;
  partner2Country?: string;
  partner2Location?: string;
}): { city: string; countryIso: string } {
  let city = (p.partner2City ?? '').trim();
  let countryIso = (p.partner2Country ?? '').trim();
  if (!city && !countryIso) {
    const leg = (p.partner2Location ?? '').trim();
    if (leg) {
      const x = parseCityCountry(leg);
      city = x.city;
      countryIso = x.country;
    }
  }
  return { city, countryIso };
}

export function countryIsoDisplay(iso: string, locale: string): string {
  const t = iso.trim();
  if (!t) return '';
  return getCountryLabel(t, locale) || t;
}
